import {BuildingLocationsGroupedByBuildingName, ConnectionsGroupedByBuilding} from './types';
import {stringCompare} from '@lib/utils';

export const connectionGroupComparator = (
  firstGroup: ConnectionsGroupedByBuilding,
  secondGroup: ConnectionsGroupedByBuilding,
  loggedInUserWorkspaceReservationBuildingId: string,
) => {
  if (
    loggedInUserWorkspaceReservationBuildingId &&
    loggedInUserWorkspaceReservationBuildingId === firstGroup.buildingId
  ) {
    return -1;
  } else if (
    loggedInUserWorkspaceReservationBuildingId &&
    loggedInUserWorkspaceReservationBuildingId === secondGroup.buildingId
  ) {
    return 1;
  }

  if (firstGroup.isDefaultBuilding) {
    return -1;
  } else if (secondGroup.isDefaultBuilding) {
    return 1;
  }

  if (firstGroup.buildingId) {
    return stringCompare(firstGroup.buildingName, secondGroup.buildingName);
  }
  return 1;
};

export const connectionByBuildingComparator = (
  a: BuildingLocationsGroupedByBuildingName,
  b: BuildingLocationsGroupedByBuildingName,
) => {
  if (a.isDefaultBuilding !== b.isDefaultBuilding) {
    if (a.isDefaultBuilding && !b.isDefaultBuilding) {
      return -1;
    } else if (!a.isDefaultBuilding && b.isDefaultBuilding) {
      return 1;
    }
  }

  const userHasNoAccessA = a.data.every((x) => !x.userHasAccess);
  const userHasNoAccessB = b.data.every((x) => !x.userHasAccess);

  if (userHasNoAccessA !== userHasNoAccessB) {
    if (!userHasNoAccessA && userHasNoAccessB) {
      return -1;
    } else if (userHasNoAccessA && !userHasNoAccessB) {
      return 1;
    }
  }

  return stringCompare(a.buildingName, b.buildingName);
};
